/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteShipmentDto } from '../../models/delete-shipment-dto';
import { DeleteShipmentResponseDto } from '../../models/delete-shipment-response-dto';

export interface BrtControllerDeleteShipment$Params {
  
    /**
     * Shipment data
     */
    body: DeleteShipmentDto
}

export function brtControllerDeleteShipment(http: HttpClient, rootUrl: string, params: BrtControllerDeleteShipment$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteShipmentResponseDto>> {
  const rb = new RequestBuilder(rootUrl, brtControllerDeleteShipment.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteShipmentResponseDto>;
    })
  );
}

brtControllerDeleteShipment.PATH = '/couriers/brt/delete-shipment';
